import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";

export interface GetDetailedAuditTrialPayload {
  order_id: string;
  name: string;
  tag: string;
}

export const getDetailedAuditTrial = async (
  payload: GetDetailedAuditTrialPayload,
) => {
  try {
    const response = await fetch(API_ENDPOINTS.GET_AUDIT_TRIAL_DETAILS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audit trial overview");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    logError(error as Error, "Error in getAuditTrialOverview");
    throw error;
  }
};
